import axios from 'axios';
import axiosRefresh from './axiosRefresh';

const axiosInstance = axios.create({
  // baseURL: "https://hackprinceton-registration-25f70f11442b.herokuapp.com",
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: 'csrf_access_token',
  xsrfHeaderName: 'X-CSRF-TOKEN',
});

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    const refreshExcludedPaths = [
      '/api/auth/login',
      '/api/auth/register',
      '/api/auth/reset_password',
      '/api/auth/token/refresh',
    ];
    const isRefreshExcluded = refreshExcludedPaths.some(path =>
      originalRequest?.url?.startsWith(path)
    );

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !isRefreshExcluded
    ) {
      originalRequest._retry = true;
      try {
        await axiosRefresh.post('/api/auth/token/refresh');
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
